import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './SearchTemplate.scss'
/**
 * creat by tianruojun
 * @description 渲染多行表单区域的模板
 * @class SearchTemplate
 * @extends {Component}
 * btnList[]:
 *      type:1 component传递dom
 *      type：2 component传递string  string仅限于当前组件旗下的组件名
 *      type: 3 component传递string  string仅限于当指定目录旗下的组件名
 */
export default class SearchTemplate extends Component {
    static propTypes = {
        /**
         * @text 初始部门id
         * @category data
         */
        deptId: PropTypes.string,
        btnList: PropTypes.array,
    };
    static defaultProps = {
        btnList: [],
        rowStyle: {}
    };

    /**
     * 处理睡觉的回调
     * @param {string} name 姓名
     */
    onSleep = (name) => {
        this.setState({name})
    };

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
        if(this.props.onColWidthsChange && typeof this.props.onColWidthsChange === 'function') {
            this.mutationObserver && this.mutationObserver.disconnect();
            this.resizeObserver && this.resizeObserver.disconnect();
        }
    }

    componentDidMount() {
        const observer = new ResizeObserver(e=>{
            e.forEach(entry=>{
                console.log(entry.target)
                this.props.onResize(entry.target.offsetHeight);
            });
        });
        const target = document.querySelector('.search-template');
        target&&observer.observe(this.ref)
        if(target && this.props.onColWidthsChange && typeof this.props.onColWidthsChange === 'function') {
            // 监听 DOM 更新
            this.observeDOMChanges(target);
            // 监听窗口大小变化
            this.observeWindowSizeChanges(target)
        }
    }

    calculateColWidths = (container) => {
        const {onColWidthsChange} = this.props;
        const items = container.querySelectorAll('.col');
        if (!items.length) return;
        requestAnimationFrame(() => { // 确保 DOM 更新完成后执行
            const colWidths = Array.from(items).filter(item => item.style.display !== 'none').map(item => item.offsetWidth);
            onColWidthsChange && onColWidthsChange(colWidths);
        });
    };

    observeDOMChanges = (target) => {
        this.mutationObserver = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                if (mutation.type === 'childList') {
                    this.mutationObserver.disconnect(); // 断开连接
                    this.debounceCalculateColWidths(target); // 调用一次
                }
            });
        });
        this.mutationObserver.observe(target, { childList: true, subtree: true });
    };

    observeWindowSizeChanges = (target) => {
        this.resizeObserver = new ResizeObserver(entries => {
            entries.forEach(entry => {
                this.debounceCalculateColWidths(entry.target);
            });
        });
        this.resizeObserver.observe(target);
    };

    debounceCalculateColWidths = debounce((container) => {
        this.calculateColWidths(container);
    }, 200); // 防抖时间间隔为 200ms


    render() {

        return (
            <div className={'search-template'} ref={(ref)=>{this.ref = ref}}>
                {
                    this.props.btnList.map((row,index)=>{
                        return this.renderRow(row,index)
                    })
                }
                <style>{`.search-template .ant-form-item {
    margin-bottom: 0px !important;
}`}</style>
            </div>
        )
    }

    // 渲染行
    renderRow = (row,index) => {
        if(!row?.length) {
            return ""
        }
        return (
            <div className={"row"} style={{display: "flex",
                flexWrap: "wrap",
                alignItems: "center", ...this.props.rowStyle}} key={index}>
                {
                    row.map((col,index)=>{
                        return this.renderCol(col,index)
                    })
                }
            </div>
        )
    };
    // 渲染列
    renderCol = (col,index) => {
        let style = {};
        if(typeof col.styleOut === "object") {
            style = {
                ...style,
                ...col.styleOut
            }
        }
        return (
            <div className={"col"} key={index} style={style}>
                {this.renderBtn(col)}
            </div>
        )
    };

    renderBtn = (config={}) => {
        let type = config.type;
        let component = config.component;
        let Component = null;

        switch (type) {
            case 1:
                Component = component;
                return Component
            case 2:
                try {
                    Component = require(`./item/${component}/${component}`).default;
                } catch (e) {
                    try {
                        Component = require(`@/custom/view/components/searchTemplate/item/${component}/${component}`).default;
                    } catch (error) {
                        console.log(e.toString())
                    }
                }

                if(Component) {
                    return <Component
                        {
                            ...config
                        }
                    />

                }
                break;
        }
    };

}

function debounce(func, wait) {
    let timeout;
    return function() {
        const context = this, args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
    };
}